<template>
    <div class="ml-5 mr-5">
          
   



        <section >
           <AutomateItemsSelection  v-if="automateOrNoneAutomateMode == 0" @itemsSelected="itemsSelected"/>
           <NonAutomateItemsSelection v-if="automateOrNoneAutomateMode == 1" @itemsSelected="itemsSelected"/>
        </section>
            

    </div>
</template>


<script>
import { mapState  } from "vuex";
import AutomateItemsSelection from './ItemsSelections/AutomateItemsSelection.vue'
import NonAutomateItemsSelection from './ItemsSelections/NonAutomateItemsSelection.vue'



export default {
    name : "ItemsSelection",
    components:{
        AutomateItemsSelection,
        NonAutomateItemsSelection,
    },
    mounted(){
      //  console.log("mount ItemsSelection")
    },
    computed:{
            ...mapState({
                dataGroupAndDetailAutomate : state => state.patho_opd_job_worklist.dataGroupAndDetailAutomate ,
                dataGroupAndDetailNonAutomate : state => state.patho_opd_job_worklist.dataGroupAndDetailNonAutomate ,


                automateOrNoneAutomateMode: state => state.patho_opd_job_worklist.automateOrNoneAutomateMode ,
            }) ,


    },
    methods:{
        itemsSelected(payload){
             this.$emit('itemsSelected',payload)
        }
    }


        
}
</script>